import { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import Status from './components/Status';
import Revoke from './components/Revoke';
import Login from './components/Login';
import Header from './components/common/Header';
import ConsentDetails from './components/ConsentDetails';
import EntitySelector from './components/EntitySelector';
import { UserProvider } from './context/UserContext';
import Footer from './components/common/Footer';
import FiuConsentDetails from './components/FiuConsentDetails';
import RouteAnnouncer from './components/common/RouteAnnouncer';
import { announceToScreenReader } from './utils/a11y.utils';
const defaultConfig = {
	'fontFamily': 'Anek Latin',
	'primaryColor': '#273C89',
	'secondaryColor': '#F5F5F5',
	'headingColor': '#191c1f',
	'subHeadingColor': '#0e65d7',
	'textColor': '#6B6D6F',
	'btnHeight': '40px',
	'btnWidth': '327px',
	'borderRadius': '8px',
	'fontSize': '12px',
	'primaryBtnColor': '#273C89',
	// #ccc gave 1.61:1 against white, failing WCAG 1.4.11 (3:1) for
	// outlined buttons where this is the only visible boundary.
	// Reusing textColor keeps the palette consistent and clears 3:1.
	'btnBorderColor': '#6B6D6F',
};
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoader: false,
			configDetails: defaultConfig,
		};
	}
	updateLoader = (val) => {
		this.setState({ isLoader: val }, () => {
			if (val) {
				announceToScreenReader('Loading, please wait', 'assertive');
			} else {
				announceToScreenReader('Loading complete', 'polite');
			}
		});
	};
	render() {
		return (
			<UserProvider>
				<div
					className="App"
					style={{ fontFamily: this.state.configDetails?.fontFamily }}
				>
					<a href="#main-content" className="skip-link">
						Skip to main content
					</a>
					<div id="sr-live-region" className="sr-only" aria-live="polite" aria-atomic="true" />
					<RouteAnnouncer />
					<div aria-hidden={this.state.isLoader ? true : undefined}>
						<Header customDetails={this.state.configDetails} />
						<main
							id="main-content"
							aria-label="Main content"
							aria-busy={this.state.isLoader ? true : undefined}
							tabIndex={-1}
						>
							<Switch>
							<Route
								exact
								path="/"
								render={(props) => (
									<Login {...props} customDetails={this.state.configDetails} />
								)}
							/>

							<Route
								exact
								path="/fip"
								render={(props) => (
									<Login {...props} customDetails={this.state.configDetails} />
								)}
							/>
							<Route
								exact
								path="/revoke-consent"
								render={(props) => (
									<Revoke
										{...props}
										updateLoader={this.updateLoader}
										customDetails={this.state.configDetails}
									/>
								)}
							/>
							<Route
								exact
								path="/entity-selection"
								render={(props) => (
									<EntitySelector
										{...props}
										updateLoader={this.updateLoader}
										customDetails={this.state.configDetails}
									/>
								)}
							/>
							<Route
								exact
								path="/status"
								render={(props) => (
									<Status
										{...props}
										updateLoader={this.updateLoader}
										customDetails={this.state.configDetails}
									/>
								)}
							/>
							<Route
								exact
								path="/consent-details"
								render={(props) => (
									<ConsentDetails
										{...props}
										updateLoader={this.updateLoader}
										customDetails={this.state.configDetails}
									/>
								)}
							/>
							<Route
								exact
								path="/fiu-consent-details"
								render={(props) => (
									<FiuConsentDetails
										{...props}
										updateLoader={this.updateLoader}
										customDetails={this.state.configDetails}
									/>
								)}
							/>
							</Switch>
						</main>
						<Footer customDetails={this.state.configDetails} />
						<div className="toast-message" role="region" aria-label="Notifications">
							<ToastContainer />
						</div>
					</div>
					{this.state.isLoader ? (
						<div
							className="application-loading-container"
							role="alert"
							aria-busy="true"
							aria-label="Loading, please wait"
						>
							<div className="snippet" data-title=".dot-pulse" aria-hidden="true">
								<div className="stage">
									<div className="dot-pulse-btn" />
								</div>
							</div>
						</div>
					) : null}
				</div>
			</UserProvider>
		);
	}
}

export default App;
